var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-menu',{attrs:{"default-active":_vm.$route.path,"router":"","active-text-color":"#009bac"}},_vm._l((_vm.pmsMenus),function(route){return _c('siderbar-item',{key:route.code,attrs:{"item":route,"base-path":"/pms"}})}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }